import React, { useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

const Edit = ({ ptor, handleCancelClick, increment, setPtorId }) => {
  const [ptor1, setPtor1] = useState(ptor);
  const axiosPrivate = useAxiosPrivate();

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setPtor1((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "jobs/ptorreason/" + ptor1.id + "/",
          ptor1,
          {
            signal: controller.signal,
          }
        );
        //isMounted && setDocuments(response.data);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    updateData();
    setPtorId(null);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  return (
    <tr>
      <td>{ptor.id}</td>
      <td>
        <input
          type="text"
          name="title"
          className="form-control"
          id="title"
          value={ptor1.title}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <textarea
          name="details"
          className="form-control"
          id="details"
          value={ptor1.details}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
